export enum ActivityPeriodDateFilterEnum {
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}
